<template>
<div style="height: 100%; position: relative;">
    <div id="d006" class="" style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"></div>
    <div class="center" style="position: absolute; bottom: 0; left: 0; right: 0;">
		<span class="dot bcPrimary"></span> Nettoomsättning
		<span class="dot bcSecondary"></span> Övriga intäkter
		<span class="dot bcTertiary"></span> Rörelsekostnader
		<span class="dot bcLightGrey"></span> Andra kostnader
		<span class="dot result"></span> Årets resultat
	</div>
</div>
</template>

<script>
    /* tslint:disable */
    import Highcharts from 'highcharts'
    import Vue from 'vue';
    import {colors} from '@/config';

    export default {
        name: "D006",
        components: {},
        props: {
            profitloss: Object
        },

        methods: {
            pos(val) {
                if (val < 0) return 0;
                return val;
            },
            neg(val) {
                if (val > 0) return 0;
                return -val;
            }
        },

        mounted() {
            this.chart = new Highcharts.chart({

                chart: {
                    type: 'column',
                    renderTo: 'd006',
                    backgroundColor: 'transparent',
                },

                credits: {
                    enabled: false,
                },

                title: {
                    text: ''
                },

                legend: {
                    enabled: false
                },

        		colors: [
                    ...Array(9).fill(colors.Secondary),
                    colors.Primary,
                    ...Array(2).fill(colors.LightGrey),
                    ...Array(5).fill(colors.Tertiary),
                    ...Array(3).fill(colors.LightGrey),
                    colors.Green, 
                    colors.Red
                ],

                xAxis: {
                    categories: this.profitloss.sheets.map( s => s.DATE_TO.substr(0, 4) ),
                    labels: { 
                        style: { fontSize: '1.2rem', } 
                    } ,
                    reversed: true,
                    reversedStacks: true,
                },

                yAxis: {
                    opposite: true,
                    allowDecimals: false,
                    title: {
                        text: ''
                    },
                    labels: {
                        formatter() { return Vue.options.filters.KR(this.value); },
                        style: { fontSize: '1.2rem', } 
                    },
                    tickPixelInterval: 150
                },

                tooltip: {
                    formatter: function () {
                        return '<b>' + this.x + '</b><br/>' +
                        this.series.name + ': ' + Vue.options.filters.TKR(this.y) + '<br/>';
                    },
                    style: { fontSize: '1.5rem', } 
                },

                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderColor: '#5d5d5d'
                    }
                },
                
                series: [{
                    name: 'Skatt',
                    data: this.profitloss.sheets.map( s => this.pos(s.Q) ),
                    stack: 'intakt'
                }, {
                    name: 'Bokslutsdispositioner',
                    data: this.profitloss.sheets.map( s => this.pos(s.O) ),
                    stack: 'intakt'
                }, {
                    name: 'Finansiella poster',
                    data: this.profitloss.sheets.map( s => this.pos(s.LM) ),
                    stack: 'intakt'
                }, {
                    name: 'Av- och nedskrivningar',
                    data: this.profitloss.sheets.map( s => this.pos(s.J) ),
                    stack: 'intakt'
                }, {
                    name: 'Övr. rörelsekostnader',
                    data: this.profitloss.sheets.map( s => this.pos(s.H) ),
                    stack: 'intakt'
                }, {
                    name: 'Personalkostnader',
                    data: this.profitloss.sheets.map( s => this.pos(s.G) ),
                    stack: 'intakt'
                }, {
                    name: 'Övr. externa kostnader',
                    data: this.profitloss.sheets.map( s => this.pos(s.F) ),
                    stack: 'intakt'
                }, {
                    name: 'Kostnader för varor & material',
                    data: this.profitloss.sheets.map( s => this.pos(s.D) ),
                    stack: 'intakt'
                }, {
                    name: 'Övriga rörelseintäkter',
                    data: this.profitloss.sheets.map( s => this.pos(s.B) ),
                    stack: 'intakt'
                }, {
                    name: 'Nettoomsättning',
                    data: this.profitloss.sheets.map( s => this.pos(s.A) ),
                    stack: 'intakt'
                }, {
                    name: 'Nettoomsättning',
                    data: this.profitloss.sheets.map( s => this.neg(s.A) ),
                    stack: 'kostnad'
                }, {
                    name: 'Övriga rörelsintäkter',
                    data: this.profitloss.sheets.map( s => this.neg(s.B) ),
                    stack: 'kostnad'
                }, {
                    name: 'Kostnader för varor & material',
                    data: this.profitloss.sheets.map( s => this.neg(s.D) ),
                    stack: 'kostnad'
                }, {
                    name: 'Övr. externa kostnader',
                    data: this.profitloss.sheets.map( s => this.neg(s.F) ),
                    stack: 'kostnad'
                }, {
                    name: 'Personalkostnader',
                    data: this.profitloss.sheets.map( s => this.neg(s.G) ),
                    stack: 'kostnad'
                }, {
                    name: 'Övr. rörelsekostnader',
                    data: this.profitloss.sheets.map( s => this.neg(s.H) ),
                    stack: 'kostnad'
                }, {
                    name: 'Av- och nedskrivningar',
                    data: this.profitloss.sheets.map( s => this.neg(s.J) ),
                    stack: 'kostnad'
                }, {
                    name: 'Finansiella poster',
                    data: this.profitloss.sheets.map( s => this.neg(s.LM) ),
                    stack: 'kostnad'
                }, {
                    name: 'Bokslutsdispositioner',
                    data: this.profitloss.sheets.map( s => this.neg(s.O) ),
                    stack: 'kostnad'
                }, {
                    name: 'Skatt',
                    data: this.profitloss.sheets.map( s => this.neg(s.Q) ),
                    stack: 'kostnad'
                }, {
                    name: 'Årets vinst',
                    data: this.profitloss.sheets.map( s => this.pos(s.R) ),
                    stack: 'kostnad'
                }, {
                    name: 'Årets förlust',
                    data: this.profitloss.sheets.map( s => s.R < 0 ? s.R : 0 ),
                    stack: 'intakt'
                }],

            });
        },

    }
</script>

<style scoped lang="scss">
    .dot {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: inline-block;
    }

    .result {
        background: linear-gradient( -45deg, #e70407, #e70407 50%, #a4e408 50%);
        border-radius: 50%;
    }

    .center {
        font-size: 1.2rem;
    }
</style>
